import { loadItem, removeItem, saveItem, storageKeys } from "../../shared/storage/index";

const DEFAULT_RESUME_PATH = "/onboarding/photos";

export function isOnboardingIncomplete(isAuthenticated, user = null) {
  if (!isAuthenticated) return false;
  if (user?.onboardingComplete) return false;
  if (user?.username) return false;
  if (loadItem(storageKeys.onboardingComplete)) return false;
  if (loadItem(storageKeys.onboardingDraft) != null) return true;
  return false;
}

export function getOnboardingResumePath() {
  const saved = loadItem(storageKeys.onboardingResumePath);
  if (typeof saved === "string" && saved.startsWith("/onboarding/")) {
    return saved;
  }
  return DEFAULT_RESUME_PATH;
}

export function saveOnboardingResumePath(path) {
  if (typeof path === "string" && path.startsWith("/onboarding/")) {
    saveItem(storageKeys.onboardingResumePath, path);
  }
}

export function clearOnboardingResumePath() {
  removeItem(storageKeys.onboardingResumePath);
}
